import React, { Component } from 'react';
import {
  MenuItem,
  TextField,
  InputAdornment,
  CircularProgress,
} from '@material-ui/core';
import { Search } from '@material-ui/icons';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import EditQuestion from './AddOrEditQuestion';
import Question from '../comps/Question';
import { getAllQuestions } from '../../../services/apiService';
import InfiniteScroll from 'react-infinite-scroll-component';

class AllQuestions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questions: [],
      loading: true,
      pageNo: 1,
      pageSize: 100,
      // filter options
      filterByDifficulty: '',
      filterByModule: '',
      filterByCompetency: '',
      filterByConcept: '',
      filterBySearch: '',
      hasMore: true,
    };
  }

  componentDidMount = () => {
    const loadData = async () => {
      try {
        const questions = await getAllQuestions({
          pageNo: 1,
          pageSize: 100,
        });

        this.setState({
          questions,
          loading: false,
        });
      } catch (e) {
        console.error(e);
        this.setState({
          errorMessage: 'Failed to load questions, Please try again later!',
        });
      }
    };

    loadData();
  };

  goback = () => {
    this.setState({ editQues: false });
    this.componentDidMount();
  };

  getMoreQuestionData = async (filterApplied = false) => {
    const questionData = await getAllQuestions({
      pageNo: this.state.pageNo,
      pageSize: this.state.pageSize,
      difficultyLevel: this.state.filterByDifficulty,
      conceptId: this.state.filterByConcept,
      competencyId: this.state.filterByCompetency,
      moduleId: this.state.filterByModule,
      searchText: this.state.filterBySearch.toLowerCase(),
    });

    if (!questionData.length || questionData.length < this.state.pageSize) {
      this.setState({ hasMore: false });
    } else {
      this.setState({ hasMore: true });
    }

    this.setState({
      questions: filterApplied
        ? questionData
        : [...this.state.questions, ...questionData],
    });
  };

  debouncedAPIcall = debounce(async () => {
    this.getMoreQuestionData(true);
  }, 500);

  componentDidUpdate = (prevProps, prevStates) => {
    if (
      this.state.filterByDifficulty !== prevStates.filterByDifficulty ||
      this.state.filterByConcept !== prevStates.filterByConcept ||
      this.state.filterByCompetency !== prevStates.filterByCompetency ||
      this.state.filterByModule !== prevStates.filterByModule ||
      this.state.filterBySearch !== prevStates.filterBySearch
    ) {
      this.setState({ pageNo: 1 }, () => this.debouncedAPIcall());
    }
  };

  render() {
    if (this.state.loading) {
      return (
        <div className='flex py-32 bg-white'>
          {this.state.errorMessage ? (
            <span className='m-auto text-red-500 text-center whitespace-pre-line'>
              {this.state.errorMessage}
            </span>
          ) : (
            <CircularProgress className='m-auto' />
          )}
        </div>
      );
    }
    return (
      <div>
        <div className='bg-white py-6 px-3'>
          {this.state.editQues ? (
            <>
              <EditQuestion
                ques={this.state.editQues}
                goBack={this.goback}
                isEditMode={true}
              />
            </>
          ) : (
            <div>
              <div className='flex gap-2 justify-between items-center px-4'>
                <span className='text-gray-500 mx-2'>
                  Total Items: {this.state.questions.length}
                </span>
                <span className='w-1/2 pl-2'>
                  <TextField
                    onChange={({ target }) =>
                      this.setState({ filterBySearch: target.value })
                    }
                    type='text'
                    value={this.state.filterBySearch}
                    placeholder='Search sdfds Question'
                    variant='outlined'
                    size='small'
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position='start'>
                          <Search className='text-gray-400' />
                        </InputAdornment>
                      ),
                    }}
                  />
                </span>
              </div>
              {/* Filter Options */}
              <div className='flex gap-2 my-4 px-4'>
                <TextField
                  select
                  onChange={({ target }) =>
                    this.setState({ filterByDifficulty: target.value })
                  }
                  value={this.state.filterByDifficulty}
                  label='Difficulty Level'
                  variant='outlined'
                  size='small'
                  fullWidth
                >
                  <MenuItem value=''>
                    <em>All</em>
                  </MenuItem>
                  <MenuItem value='easy'>Easy</MenuItem>
                  <MenuItem value='medium'>Medium</MenuItem>
                  <MenuItem value='hard'>Hard</MenuItem>
                </TextField>

                <TextField
                  select
                  onChange={({ target }) =>
                    this.setState({ filterByModule: target.value })
                  }
                  value={this.state.filterByModule}
                  label='Module (L1)'
                  variant='outlined'
                  size='small'
                  fullWidth
                >
                  <MenuItem value=''>
                    <em>All</em>
                  </MenuItem>
                  {this.props.modules.map((mdl) => (
                    <MenuItem value={mdl.id} key={mdl.id}>
                      {mdl.name}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  select
                  onChange={({ target }) =>
                    this.setState({ filterByCompetency: target.value })
                  }
                  value={this.state.filterByCompetency}
                  label='Competency (L2)'
                  variant='outlined'
                  size='small'
                  fullWidth
                >
                  <MenuItem value=''>
                    <em>All</em>
                  </MenuItem>
                  {this.props.competencies.map((cmp) => (
                    <MenuItem value={cmp.id} key={cmp.id}>
                      {cmp.name}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  select
                  onChange={({ target }) =>
                    this.setState({ filterByConcept: target.value })
                  }
                  value={this.state.filterByConcept}
                  label='Concept (L3)'
                  variant='outlined'
                  size='small'
                  fullWidth
                >
                  <MenuItem value=''>
                    <em>All</em>
                  </MenuItem>
                  {this.props.concepts.map((cpt) => (
                    <MenuItem value={cpt.id} key={cpt.id}>
                      {cpt.name}
                    </MenuItem>
                  ))}
                </TextField>
              </div>

              <InfiniteScroll
                dataLength={this.state.questions?.length}
                next={() => {
                  this.setState({ pageNo: this.state.pageNo + 1 });
                  this.getMoreQuestionData();
                }}
                hasMore={this.state?.hasMore}
                scrollThreshold='200px'
                loader={<h4 className='text-center'>Loading...</h4>}
                endMessage={
                  <p className='text-center'>
                    <b>No More Results to show</b>
                  </p>
                }
              >
                <div className='flex flex-col divide-y divide-gray-300'>
                  {this.state.questions?.map((ques, index) => (
                    <Question
                      ques={ques}
                      editQues={(ques) => this.setState({ editQues: ques })}
                      updateList={this.componentDidMount}
                      index={index}
                      key={ques.id}
                    />
                  ))}
                </div>
              </InfiniteScroll>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ questionLevelsReducer }) => ({
  ...questionLevelsReducer,
});

export default connect(mapStateToProps)(AllQuestions);
